module.exports = __webpack_public_path__ + "static/media/info_icon.3c0c0f32.svg";